// This file is automatically generated. See gqlcodegen.yml for details
var result = {
    "possibleTypes": {
        "Action": [
            "ActivityAddAction",
            "ActivityRateAction",
            "BreathHoldingAction",
            "CopingCardAddAction",
            "CopingCardReviewAction",
            "EatingLogAddAction",
            "HopeKitAddAction",
            "HopeKitReviewAction",
            "HyperventilationAction",
            "MyPlanReviewAction",
            "RelaxAction",
            "SleepDiaryEntryMorningAction",
            "SleepDiaryEntryNightAction",
            "StaticAction",
            "ThoughtDiaryEntrySpotAction",
            "ThoughtDiaryEntrySwitchAction",
            "ThoughtDiaryEntryTestAction",
            "WordPairingAction"
        ],
        "BaseError": [
            "InvalidPasswordError",
            "OutdatedBotStateError",
            "SimpleError",
            "UserDisabledError",
            "ValidationError"
        ],
        "CareTeamEntity": [
            "Organization",
            "Practitioner"
        ],
        "HopeKitItem": [
            "HopeKitImage",
            "HopeKitQuote",
            "HopeKitVideo"
        ],
        "IPatientProfile": [
            "Patient",
            "PatientProfile"
        ],
        "LegacyQuizSetItem": [
            "LegacyQuizSetItemMultipleChoiceQuestion",
            "LegacyQuizSetItemSingleChoiceQuestion",
            "LegacyQuizSetItemVideo"
        ],
        "MutationAcceptYstNominationResult": [
            "SimpleError",
            "YstNomination"
        ],
        "MutationAddEatingCheckinResult": [
            "EatingCheckinPractice",
            "SimpleError"
        ],
        "MutationAddEatingProgressEntryResult": [
            "EatingProgressEntryPractice",
            "SimpleError"
        ],
        "MutationAddYstSupporterEventResult": [
            "SimpleError",
            "YstSupportProfile"
        ],
        "MutationCreateJobResult": [
            "Job",
            "SimpleError",
            "ValidationError"
        ],
        "MutationCreateTestScenarioResult": [
            "CreateTestScenarioResult",
            "SimpleError",
            "ValidationError"
        ],
        "MutationDeclineYstNominationResult": [
            "SimpleError",
            "YstNomination"
        ],
        "MutationInviteYSTGuardianResult": [
            "Patient",
            "SimpleError",
            "ValidationError"
        ],
        "MutationInviteYSTYouthResult": [
            "Patient",
            "SimpleError",
            "ValidationError"
        ],
        "MutationLoginWithEmailResult": [
            "InvalidPasswordError",
            "SimpleError",
            "UserDisabledError",
            "UserSession"
        ],
        "MutationLoginWithTokenResult": [
            "InvalidPasswordError",
            "SimpleError",
            "UserDisabledError",
            "UserSession"
        ],
        "MutationNominateYstSupportersResult": [
            "MutationNominateYstSupportersSuccess",
            "SimpleError",
            "ValidationError"
        ],
        "MutationPersistBotStateResult": [
            "BotState",
            "OutdatedBotStateError",
            "SimpleError"
        ],
        "MutationPreviewYstPatientMessageResult": [
            "SimpleError",
            "YstPatientMessagePreview"
        ],
        "MutationRateYstSupporterCheckinResult": [
            "SimpleError",
            "YstSupporterCheckin"
        ],
        "MutationResendYstNominationInviteResult": [
            "SimpleError",
            "ValidationError",
            "YstNomination"
        ],
        "MutationResendYstPatientMessageResult": [
            "MutationResendYstPatientMessageSuccess",
            "SimpleError"
        ],
        "MutationSignupYSTGuardianResult": [
            "Patient",
            "SimpleError",
            "ValidationError"
        ],
        "MutationSignupYSTYouthResult": [
            "Patient",
            "SimpleError",
            "ValidationError"
        ],
        "MutationUpdateEatingCheckinResult": [
            "EatingCheckinPractice",
            "SimpleError"
        ],
        "MutationUpdateEatingProgressEntryResult": [
            "EatingProgressEntryPractice",
            "SimpleError"
        ],
        "MutationUpdateFirstCheckinDateResult": [
            "MutationUpdateFirstCheckinDateSuccess",
            "SimpleError",
            "ValidationError"
        ],
        "MutationUpdateOnboardingAvailabilityResult": [
            "MutationUpdateOnboardingAvailabilitySuccess",
            "SimpleError"
        ],
        "MutationUpdateOuiUserResult": [
            "CurrentOuiUser",
            "InvalidPasswordError",
            "SimpleError",
            "ValidationError"
        ],
        "MutationUpdatePracticeResult": [
            "SimpleError",
            "UpdatePracticeResult"
        ],
        "MutationUpdateRecurringAvailabilityResult": [
            "MutationUpdateRecurringAvailabilitySuccess",
            "SimpleError"
        ],
        "MutationUpdateYstMentalHealthConcernsResult": [
            "MutationUpdateYstMentalHealthConcernsSuccess",
            "SimpleError"
        ],
        "MutationUpdateYstSupporterEventResult": [
            "SimpleError",
            "YstSupportProfile"
        ],
        "OrganizationProductConfig": [
            "OrganizationAvivaConfig",
            "OrganizationYstConfig"
        ],
        "OuiUserType": [
            "OuiAdmin",
            "Patient",
            "Practitioner",
            "Registrar"
        ],
        "PendingAction": [
            "PendingActivityAddAction",
            "PendingActivityRateAction",
            "PendingBreathHoldingAction",
            "PendingCopingCardAddAction",
            "PendingCopingCardReviewAction",
            "PendingEatingLogAddAction",
            "PendingHopeKitAddAction",
            "PendingHopeKitReviewAction",
            "PendingHyperventilationAction",
            "PendingMyPlanReviewAction",
            "PendingRelaxAction",
            "PendingSleepDiaryEntryMorningAction",
            "PendingSleepDiaryEntryNightAction",
            "PendingThoughtDiaryEntrySpotAction",
            "PendingThoughtDiaryEntrySwitchAction",
            "PendingThoughtDiaryEntryTestAction",
            "PendingWordPairingAction"
        ],
        "Practice": [
            "ActivityPractice",
            "BreathHoldingPractice",
            "EatingCheckinPractice",
            "EatingCommitmentEntryPractice",
            "EatingLogEntryPractice",
            "EatingProgressEntryPractice",
            "HyperventilationPractice",
            "RelaxDiaryEntryPractice",
            "SleepDiaryEntryPractice",
            "ThoughtDiaryEntryPractice",
            "WordPairingPractice"
        ],
        "QuizSetItem": [
            "QuizSetItemChoice",
            "QuizSetItemVideo"
        ],
        "RoleProductConfig": [
            "RoleAvivaConfig",
            "RolePtsdConfig"
        ],
        "RoleSettings": [
            "ChangeBiteRoleSettings"
        ],
        "Widget": [
            "ActivityDiaryWidget",
            "BingeEatingMyPlanWidget",
            "BreathHoldingWidget",
            "CopingCardsWidget",
            "EatingLogWidget",
            "HopeKitWidget",
            "HyperventilationWidget",
            "MyPlanWidget",
            "RelaxDiaryWidget",
            "SleepDiaryWidget",
            "ThoughtDiaryWidget",
            "WordPairingWidget"
        ],
        "YstProfile": [
            "YstGuardianProfile",
            "YstSupportProfile",
            "YstYouthProfile"
        ],
        "YstSupporterActivity": [
            "YstSupporterCheckin",
            "YstSupporterEvent"
        ]
    }
};
export default result;
